import React, { Fragment } from 'react'
import classnames from 'classnames'
import TasksContainer from '@app/containers/students/Tasks'
import Tasks from '@app/components/students/Tasks'
import Logo from '@app/components/shared/Logo'
import { CompetitionPart } from '@app/components/shared/students/LandingPart'
import Timeline from "@app/components/shared/Timeline";

const TrialTasks = ({ global, student }) => {
  const classes = classnames(
    'student-tasks-page',
    'student-tasks-page--trial'
  )

  return (
    <Fragment>
      <div className={classes}>
        <div className="student-tasks-page__inner">
          <div className="student-tasks-page__content-wrapper">
            <div className="student-tasks-page__tasks-wrapper">
              <TasksContainer student={student} tour="trial" ChildComponent={Tasks} />
            </div>
          </div>
        </div>
      </div>
      <CompetitionPart global={global} />
    </Fragment>
  )
}

export default TrialTasks
